import SignaturePad from "signature_pad";
import { render_sign } from "../functions";
import {FlightService} from "../Pages/FlightServicesPage";
import {ModalContainerTGO} from "./ModalContainerTGO";

var ModalPAK = {
    view: function (ctrl, args) {
        return m('div.dm-overlay',
            m("div.dm-table", [
                m("div.dm-cell", [
                    m("div.dm-modal", [
                        m(".bg-primary[style='padding:10px;z-index:1;']", [
                            m("span[id='titleModal']", "Карта учета"),
                            m("span.pull-right[style='cursor: pointer;']", {
                                onclick: ModalContainerPAK.close
                            }, [
                                m("i.glyphicon.glyphicon-remove"),
                                m.trust('&nbsp;Закрыть')
                            ]),
                        ]),
                    m("div[style='margin-top: 5px;']", [
                        m("ul.list-group[style='margin-top: 15px;']", [
                            FlightService.list.map(function (service) {
                                return [ service.value ?
                                    m("li.list-group-item.row[style='margin: 0 4px;']", [
                                        m(".col-xs-8[style='']", [
                                            m("span", {
                                                class: ''
                                            }, service.title)
                                        ]),
                                        m(".col-xs-4[style='']", [
                                            m("span", {
                                            }, service.value + " " + service.measureUnit + "")
                                        ])
                                    ]) : ""
                                ];
                            }),
                            m(".container[style='padding-top: 15px;']", [
                                m("b", "Подпись представителя:")
                            ]),
                            m("div[style='margin: 15px 0; padding: 0 15px;']", [
                                m("div.signature-pad[style='']", [
                                    m("canvas[style='border: 1px solid #000;'][id='canvasSignPAK']", ""),
                                    m(".row", [
                                        m(".col-xs-6",[
                                            m("button.btn.btn-success.btn-md", {
                                                id: "save_sign_PAK"
                                            }, "Сохранить")
                                        ]),
                                        m(".col-xs-6",[
                                            m("button.btn.btn-info.btn-md", {
                                                id: "clear_sign_PAK",
                                                onclick: function () {
                                                    var canvas = document.querySelector("canvas");
                                                    if (canvas !== null) {
                                                        var signaturePad = new SignaturePad(canvas, {
                                                            backgroundColor: 'rgb(255, 255, 255)'
                                                        });
                                                        signaturePad.clear();
                                                    }
                                                }
                                            }, "Очистить")
                                        ])
                                    ]),
                                ])
                            ])
                        ])
                    ])
                ])
            ])
            ])
        );
    }
};

export var ModalContainerPAK = {
    container: null,
    init: function (ctrl) {
        ModalContainerPAK.container = document.querySelector('#modalСontainerPAK');
        if (!ModalContainerPAK.container) {
            ModalContainerPAK.container = document.createElement('div');
            ModalContainerPAK.container.id = 'modalСontainerPAK';
            ModalContainerPAK.container.hidden = true;
            document.body.appendChild(ModalContainerPAK.container);

            m.mount(ModalContainerPAK.container, m.component(ModalPAK, {data:  ctrl}));
        }
    },
    open: function (ctrl) {
        ModalContainerPAK.container = document.querySelector('#modalСontainerPAK');
        if (!ModalContainerPAK.container) {
            ModalContainerPAK.container = document.createElement('div');
            ModalContainerPAK.container.id = 'modalСontainerPAK';
            document.body.appendChild(ModalContainerPAK.container);

            m.mount(ModalContainerPAK.container, m.component(ModalPAK, {data: ctrl}));
        }
        ModalContainerPAK.container.hidden = false;
    },
    close: function () {
        let canvas = document.querySelector("canvas");
        if (canvas !== null) {
            let signaturePad = new SignaturePad(canvas, {
                backgroundColor: 'rgb(255, 255, 255)'
            });
            signaturePad.clear();
        }
        ModalContainerPAK.container.hidden = true;
    }
};
